// Generated by GitHub Copilot
import { forwardRef } from 'react'
import type { LucideProps } from 'lucide-react'
import { cn } from '#core/utils/cn.ts'

type MicrosoftLogoProps = Omit<LucideProps, 'children' | 'color' | 'strokeWidth' | 'absoluteStrokeWidth'>

/** Microsoft's four-square brand mark, in its own colours, for "Sign in with Microsoft" actions. */
const MicrosoftLogo = forwardRef<SVGSVGElement, MicrosoftLogoProps>(
  ({ size = 24, className = '', ...rest }, ref) => (
    <svg
      ref={ref}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      stroke='none'
      className={cn('lucide lucide-microsoft-logo', className)}
      {...rest}
    >
      <path fill='#F25022' d='M1.5 1.5H11.5V11.5H1.5Z' />
      <path fill='#7FBA00' d='M12.5 1.5H22.5V11.5H12.5Z' />
      <path fill='#00A4EF' d='M1.5 12.5H11.5V22.5H1.5Z' />
      <path fill='#FFB900' d='M12.5 12.5H22.5V22.5H12.5Z' />
    </svg>
  ),
)

MicrosoftLogo.displayName = 'MicrosoftLogo'

export default MicrosoftLogo
